import * as React from 'react';
import { TikTokEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var TikTok = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(TikTokEmbed, { url: link, width: "100%" })));
};
